export class FirebaseUserModel {
  email: string;
  name: string;
  phone: string;
  provider: string;

  constructor() {
    this.email = '';
    this.name = '';
    this.phone = '';
    this.provider = '';
  }
}
